import { useState } from "react";
import { Link } from "react-router-dom";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
  {
  question: "Will there be another Watermelon Run?",
  answer: (
    <>
     Yes, mark your calender for September 26th, 2026! Keep updated by following us on Instagram{" "}
      <a
        href="https://instagram.com/sowscholarship"
        target="_blank"
        rel="noopener noreferrer"
        className="faq-link"
      >
        @sowscholarship
      </a>.
    </>
  )
},

    {
      question: "What does the name \"Seeds of a Watermelon Scholarship\" mean?",
      answer:( <>The name Seeds of a Watermelon is a symbol of perseverance. Just as a watermelon, with its deep roots and vibrant fruit, has become a quiet emblem of Palestinian identity and endurance, this fund seeks to plant seeds of hope in the minds of those who have been forced to start over.</> )
    },
    {
      question: "How does the tutor program work?",
      answer:
        "It’s simple:\n1. You are matched with a tutor that best fits your needs.\n2. Meet with your tutor.\n3. Repeat!"
    },
 {
  question: "Is the tutoring program free?",
  answer: (
    <>
      Yes, this service is completely FREE! That being said, we are trying to fund education through education, so many students contribute their usual tutor fee to the SOWS Fund, which can be donated to{" "}
      <a
        href="https://leonardeducation.org/the-seeds-of-a-watermelon-scholarship-fund/"
        target="_blank"
        rel="noopener noreferrer"
        className="faq-link"
      >
        here
      </a>!
    </>
  )
},

    {
      question: "How can I join the team as a tutor?",
      answer:(    <>
      Apply to become a tutor by clicking{" "}
      <Link to="/register" className="faq-link">
        Apply here
      </Link>.
    </>)
    },
    {
      question: "How can I support SOWS?",
      answer:
      <>
        Have a skill you would like to contribute? (social media, project management, event planning, design, good ideas, tutoring, 5K volunteering, etc). Sign up or email us with more information. If you are interested in contributing to the SOWS Fund financially, follow this link{" "}
      {" "}
      <a
        href="https://leonardeducation.org/the-seeds-of-a-watermelon-scholarship-fund/"
        target="_blank"
        rel="noopener noreferrer"
        className="faq-link"
      >
        here
      </a>!
        </>
    }
  ];

  return (
    <div className="faq-container">

      <h1 className="faq-title">Frequently Asked Questions</h1>

      {faqs.map((faq, index) => (
        <div 
          key={index} 
          className={`faq-card ${openIndex === index ? "open" : ""}`}
        >
          <div 
            className="faq-question"
            onClick={() => toggle(index)}
          >
            {faq.question}
            <span className="faq-icon">
              {openIndex === index ? "−" : "+"}
            </span>
          </div>

          {openIndex === index && (
            <div className="faq-answer">
             {typeof faq.answer === "string" ? (
  faq.answer.split("\n").map((line, i) => (
    <p key={i}>{line}</p>
  ))
) : (
  <p>{faq.answer}</p>
)}
            </div>
          )}
        </div>
      ))}

    </div>
  );
}

